
// vue
import { defineComponent, ref, onMounted } from 'vue';

import { useToast } from 'vue-toastification';


// components

// services
import { useTileManagementService } from '@/api/service/tile-management.service';

export default defineComponent({
    components: {
    },
    setup() {
        // services
        const {
            convertDTM
        } = useTileManagementService();


        const toast = useToast();

        // properties
        const isLoading = ref(true);

        const isUploading = ref(false);

        const fileInput = ref<HTMLInputElement>();

        const inputData = ref({
            sourceEPSG: '',
            zoomMin: '',
            zoomMax: '',
            sourceNoDataValue: '',
            pngCompression: '',
            quantization: '',
        });

        const selectedFile = ref<File | null>(null);

        const isShowAdvancedOptions = ref(false);

        const toggleAdvancedOptions = () => {
            isShowAdvancedOptions.value = !isShowAdvancedOptions.value;
            if (!isShowAdvancedOptions.value) {
                inputData.value.sourceNoDataValue = '';
                inputData.value.pngCompression = '';
                inputData.value.quantization = '';
            }
        };

        const resetInputData = () => {
            inputData.value.sourceEPSG = '';
            inputData.value.zoomMin = '';
            inputData.value.zoomMax = '';
            inputData.value.sourceNoDataValue = '';
            inputData.value.pngCompression = '';
            inputData.value.quantization = '';
        };

        const uploadAndDownload = async (data: FormData) => {
            try {

                toast.info("File is being uploaded and converted. Please don't close or refresh the page. It might take a few minutes depending on the size of the file.");

                isUploading.value = true;

                const response = await convertDTM(data);

                const blob = new Blob([response.data]);

                const url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");

                link.href = url;
                link.download = "dtm.mbtiles";

                document.body.appendChild(link);

                link.click();

                toast.success("DTM generated successfully!");

                link.remove();

                window.URL.revokeObjectURL(url);

                selectedFile.value = null;

                if (fileInput.value) {
                    fileInput.value.value = "";
                }

                resetInputData();
            } catch (e) {
                // eslint-disable-next-line no-use-before-define
                console.error(e); // eslint-disable-line
                toast.error("Failed to generate DTM.");
            } finally {
                isUploading.value = false;
            }

        };

        const onFileSelected = (event: Event) => {
            const input = event.target as HTMLInputElement;

            if (!input.files?.length) {
                return;
            }

            selectedFile.value = input.files[0];
        };

        const convert = async () => {
            isLoading.value = true;
            if (!selectedFile.value) {
                toast.warning("Please select a TIF file!");
                return;
            }

            const data = new FormData();

            data.append("file", selectedFile.value);

            data.append("sourceEPSG", inputData.value.sourceEPSG);
            data.append("zoomMin", inputData.value.zoomMin);
            data.append("zoomMax", inputData.value.zoomMax);

            if (isShowAdvancedOptions.value) {
                data.append("sourceNoDataValue", inputData.value.sourceNoDataValue);
                data.append("pngCompression", inputData.value.pngCompression);
                data.append("quantization", inputData.value.quantization);
            }
            await uploadAndDownload(data);
            isLoading.value = false;
        };


        const handleUploadFile = async () => {
            // eslint-disable-next-line no-use-before-define
            fileInput.value?.click(); // eslint-disable-line
        }



        // lifecycle hooks
        onMounted(async () => {
            isLoading.value = true;
            isLoading.value = false;
        });

        return {
            selectedFile,
            handleUploadFile,
            fileInput,
            isLoading,
            isUploading,
            inputData,
            convert,
            onFileSelected,
            isShowAdvancedOptions,
            toggleAdvancedOptions
        };
    },
});
